import React, { useContext } from "react";
import { TestsContext, TargetsContext } from "../../contexts";
import { AboutLink } from "../common";

export const AboutLatencyChart = (props) => {
  const { className, targetIndex } = props;
  const { tests } = useContext(TestsContext);
  const targets = useContext(TargetsContext);
  const { area, country } = targets[targetIndex];

  return (
    <>
      <div className={className}>
        <AboutLink id='about-latency-chart' label='About this chart'>
          {`This chart shows ${tests.times[targetIndex].length} latency measurements (pings) against a server in ${area}, ${country}`}
        </AboutLink>
      </div>
    </>
  );
};
